<template>

    <div>
        <div class="table-name">
            {{$t('externalTranslations.externalTranslation')}}
        </div>

        <div class="columns">
            <div>
                {{$t('externalTranslations.provider')}}
            </div>
            <div>
                {{$t('externalTranslations.translation')}}
            </div>
        </div>

        <div class="result-table">

            <div v-for="(item, index) in externalTranslationVariants"
                 :key="'ext' + index">

                <div class="variant-container"
                     @click="setDraftValue(item)">
                    <div class="provider">
                        {{providerName(item)}}
                    </div>
                    <div>
                        {{item.translation}}
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script lang="ts">
    import { defineComponent, PropType } from 'vue';

    import { TranslationSegment } from '@/models/TranslationSegment';
    import { ExternalTranslationResult } from '@/models/TranslationVariants';

    import { segmentModificationService } from '@/services/translationSegment/segmentModificationService';
    import { externalProvidersStore } from '@/stores/externalProvidersStore';

    export default defineComponent({
        props: {
            translationSegment: Object as PropType<TranslationSegment>,
        },
        data() {
            return {
                segmentModificationService: segmentModificationService.getInstance(),
                externalProvidersStore: externalProvidersStore(),
            }
        },

        computed: {
            externalTranslationVariants(): any {
                if (this.translationSegment?.externalTranslationVariants == undefined || this.translationSegment.externalTranslationVariants == null) {
                    return [];
                }
                return this.translationSegment.externalTranslationVariants.translations;
            }, 

        },

        methods: {
            providerName(variant: ExternalTranslationResult) {
                return this.externalProvidersStore.getProviderName(variant.provider);
            },
            async setDraftValue(variant: ExternalTranslationResult) {
                await this.segmentModificationService.setExternalTranslationAsDraft(this.translationSegment as TranslationSegment, variant);
            },             

        }

    })
</script>

<style lang="scss" scoped>
    .table-name {
        display: flex;
        align-items: center;
        color: black;
        font-size: 17px;
        font-weight: 600;
        color: var(--text-color);
    }

    .columns {
        display: flex;
        justify-content: space-between;
        margin-top: 10px;
        font-size: 16px;
        font-weight: 600;
        color: var(--text-color);
    }

    .result-table {
        border-style: solid;
        border-width: 1px;
        border-color: var(--dark-blue);
    }

    .variant-container {
        display: flex;
        justify-content: space-between;
        padding: 10px;
        cursor: pointer;
        color: var(--text-color);

        .provider{
            margin-right: 15px;
        }
        
        & > div {
            padding: 5px;
            display: flex;
            justify-content: center;
            align-items: center;
        }
    }
</style>